module.exports = __webpack_public_path__ + "assets/img/cs-joins-ludimos.ec1dcd89.jpg";